export default {
  /**
   * 获取现场证据
   */
  async getOnSiteEvidence (caseId) {
    // await this.api('client.caseList.getOnSiteEvidence', {
    //   caseId: caseId
    // }).then(res => {
    //   this.methods('showOnSiteEvidence', res.data)
    // })
    let res = {
      "id": "00791ea2-0f99-4cc0-a764-009f6f671a10",
      "sessionId": "b94229c5-30b4-4c14-b93b-35e70710438c",
      "code": "0",
      "message": "",
      "memo": "",
      "data": {
        "credentials":[{
          "fileName": "证件正面.jpg",
          "fileUrl": "static/imgs/zhengjian.jpg",
          "uploadTime": "2018/01/15 12:12"
        }],
        "noticesPaper": [{
          "fileName": "告知书正面.jpg",
          "fileUrl": "static/imgs/gaozhi.jpg",
          "uploadTime": "2018/01/15 12:12"
        }],
        "volunteerPaper": [{
          "fileName": "志愿书正面.jpg",
          "fileUrl": "static/imgs/ziyuan.jpg",
          "uploadTime": "2018/01/15 12:12"
        }],
        "receipt": [{
          "fileName": "收据.jpg",
          "fileUrl": "static/imgs/shouju.jpg",
          "uploadTime": "2018/01/15 12:12"
        }],
        "handlePaper": [{
          "fileName": "处理书正面.jpg",
          "fileUrl": "static/imgs/chuli.jpg",
          "uploadTime": "2018/01/15 12:12"
        }]
      }
    }
    this.methods('showOnSiteEvidence', res)
  },
  /**
   * 上传文件
   */
  uploadFiles (files, newNames, mode) {
    let formData = new FormData()
    for (let file in files) {
      formData.append(file.name, file)
    }
    this.methods('uploadResult', {
      code: '0',
      message: '',
      data: true
    })
  },
  /**
   * 处理车辆黑名单
   * @param carBlacklistId 黑名单id
   * @param dodgingTollId Array 记录ids
   * @param data
   */
  dealCarBlack (carBlacklistId, dodgingTollId, data) {
    this.api('client.carBlacklist.handleDodgingTollItems', {
      carBlacklistId: carBlacklistId,
      dodgingTollId: dodgingTollId,
      credentials: data.credentials,
      noticesPaper: data.noticesPaper,
      volunteerPaper: data.volunteerPaper,
      receipt: data.receipt,
      handlePaper: data.handlePaper
    }).then(res => {
      this.methods('dealResult', res.data)
    })
  },
  /**
   * 处理人脸黑名单
   * @param manBlacklistId 黑名单id
   * @param dodgingTollId  单条记录id
   * @param data
   */
  dealManBlack (manBlacklistId, dodgingTollId, data) {
    this.api('client.manBlacklist.handleDodgingTollItem', {
      manBlacklistId: manBlacklistId,
      dodgingTollId: dodgingTollId,
      credentials: data.credentials,
      noticesPaper: data.noticesPaper,
      volunteerPaper: data.volunteerPaper,
      receipt: data.receipt,
      handlePaper: data.handlePaper
    }).then(res => {
      this.methods('dealResult', res.data)
    })
  }
}
